import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [ "toggleable", "icon" ]
  static values = { toggleClass: { type: String, default: "hidden" } }

  toggle(event) {
    event.preventDefault()

    this.toggleableTargets.forEach( target => {
      target.classList.toggle(this.toggleClassValue)
    })

    this.iconTargets.forEach( icon => { 
      icon.classList.toggle(this.toggleClassValue) 
    })
  }
}
